<script lang="ts">
  import { Button } from "@tastyworks/ui-library"
  import { _ } from "svelte-i18n"
  import {
    requestSessionCode,
    sessionCode,
    sessionLoading,
  } from "./session-store"

  interface Props {
    onError?: (error: unknown) => void
  }

  let { onError }: Props = $props()
</script>

<div class="mt-4">
  {#if !$sessionCode}
    <Button
      variant="blue"
      size="medium"
      disabled={$sessionLoading}
      onclick={() => requestSessionCode(onError)}
    >
      {$sessionLoading
        ? $_("cobrowse.buttonLoading")
        : $_("cobrowse.buttonDefault")}
    </Button>
  {:else}
    <p class="text-sm">{$_("cobrowse.codeLabel")}</p>
    <p class="my-1 text-3xl font-bold tracking-widest">{$sessionCode}</p>
    <p class="text-general-secondary-label text-xs">
      {$_("cobrowse.codeInstructions")}
    </p>
  {/if}
</div>
